import React from "react";
import {
  Navbar,
  Nav,
  Button,
  Dropdown,
  Row,
  Col,
  Toast,
  Modal,
} from "react-bootstrap";
import { Menu, Notifications, Close, Chat } from "@material-ui/icons";
import userImage from "./../../assets/img/property-placeholder.jpg";
import Logo from "./../../assets/img/logo.png";
import { connect } from "react-redux";
import { logout, myProfileAction } from "./../../actions/UserActions";
import $ from "jquery";
import {
  getNotificatioListAction,
  readNotificationsAction,
  getNotificatiosCntAction,
} from "../../actions/NotificationActions";
import io from "socket.io-client";
import NotificationList from "./../Notification/NotificationList";
import PhoneNumber from "../Common/phoneNumber";
import { cryptoTokenDecode } from "./../Common/Common";
import UrlConstants from "./../../config/UrlConstants";
import * as message from "./../../config/CommonMessages";
import * as code from "./../../config/Constants";
import { getallpermissions } from "../../actions/UserActions";
import ChangeCompany from "../ChangeCompany/ChangeCompany";
import { updatetoken } from "../../actions/UserActions.js";
import { grtAllCompanylistbyVendorId } from "../../actions/MasterTemplateActions";
import { set } from "lodash";
import { setRenderSide } from "../../actions/rerander";
import { REACT_APP_CRYPTO_SECRET_KEY } from "../../config/Constants.jsx";
import { getCurrentSystemVersionAction } from "../../actions/SystemVersionAction";
var CryptoJS = require("crypto-js");

class Header extends React.Component {
  constructor(props) {
    super(props);
    let userType = cryptoTokenDecode().usertype;
    let userID = cryptoTokenDecode();
    this.state = {
      showLoader: false,
      loggedFName: localStorage.getItem("fname"),
      loggedLName: localStorage.getItem("lname"),
      userType: userType.toUpperCase(),
      userId: userID._id,
      showNotification: false,
      userNotifications: [],
      totalUnreadCnt: 0,
      notificationMsg: [],
      totalCount: 0,
      permission: "",
      permissionArray: [],
      companyModalOpenClose: false,
      showChangecompanyOption: true,
      rerander: false,
    };
    this.readNotification = this.readNotification.bind(this);
  }

  componentWillMount() {
    this.setState({
      showLoader: true,
    });
    this.props.myProfileAction().then((res) => {
      this.setState({
        showLoader: false,
      });
    });
    this.getSystemVersion();
  }

  /**
   * @desc get unread count of notification - api call
   */
  getUnreadCount() {
    this.props
      .getNotificatiosCntAction()
      .then((res) => {
        this.setState({ totalUnreadCnt: res });
      })
      .catch((err) => {
        this.setState({ totalUnreadCnt: 0 });
      });
  }

  componentDidMount() {
    if (window.innerWidth < 991) {
      var that = this;
      $(".sidebar .nav-link").click(function() {
        that.handleChange();
      });
    }

    if (this.state.userType !== message.ADMIN) {
      this.getUnreadCount();
      this.notifications();

      const socket = io.connect(process.env.REACT_APP_SOCKET_SERVER, {
        secure: true,
        reconnect: true,
        transport: ["websocket"],
      });

      // send userId to socket
      socket.emit("Agentjoin", {
        id: this.state.userId,
      });

      // New msg notification received
      socket.on("new_msg", (data) => {
        let notificationData = JSON.parse(data.msg);
        this.showNotificationToast(notificationData);
        this.getUnreadCount();
        // update count and notification list
        this.notifications();
      });
    }

    this.getUserPermissions();
    // calling a api for finding all owners of logged-in vendor.
    // if (this.state.userType === "VENDOR")
    this.getAllCompanyListByVendor();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.renderHeader !== this.props.renderHeader) {
      this.getUserPermissions();
      // this.getAllCompanyListByVendor();
    }
  }

  getSystemVersion = () => {
    this.props.getCurrentSystemVersionAction().then((res) => {
      if (res.status === 200 && res.data.length > 0) {
        localStorage.setItem("systemVersion", res.data[0].version);
        if (res.data[0].referenceLink != "https://www.") {
          localStorage.setItem(
            "systemVersionLink",
            res.data[0].referenceLink
          );
        }
      }
    });
  };
  getAllCompanyListByVendor = () => {
    this.props.grtAllCompanylistbyVendorId().then((res) => {
      // this.setState({ contactownerdata: res.data, showLoader: false });
      if (res.status === 200) {
        // console.log("res75", res.data);
        if (res && res.data && res.data.length === 1) {
          console.log("res751>>>>>>>>>>", res.data);
          this.setState({ showChangecompanyOption: false });
        } else {
          this.setState({ showChangecompanyOption: true });
          // console.log("res752", res.data);
        }
      }
    });
  };

  chooseComapnyCallback = (ownerId, selectedCompanyname) => {
    // than update a token with owner Id
    let id = localStorage.getItem("ID");
    // console.log("138id", id);
    // console.log("138ownerId", ownerId);
    let changeflag = false;
    localStorage.setItem("ownerId", ownerId);
    if (id === ownerId) {
      //means change usertype acctowner forcefully.
      changeflag = true;
    }
    this.props.updatetoken(changeflag).then((res) => {
      localStorage.setItem("accessToken", res.data);
      this.getVendorRole(res.data);
      let usertype = cryptoTokenDecode().usertype;
      // console.log("usertype139", usertype);
      this.setState({ companyModalOpenClose: false, userType: usertype });
      localStorage.setItem("usertype", usertype);
      if (changeflag) {
        // console.log("===153===props39", this.props.renderSidebar);
        this.props.setRenderSide(Math.random());
        localStorage.removeItem("ownerId");
      }
      localStorage.setItem(
        "companyName",
        selectedCompanyname.companyInformation.name
      );
      this.props.history.push("/UserProfile");
    });
  };

  getVendorRole(accessToken) {
    let playload = "";
    let bytes = CryptoJS.AES.decrypt(accessToken, REACT_APP_CRYPTO_SECRET_KEY);
    let decryptedData = bytes.toString(CryptoJS.enc.Utf8);
    // console.log('decryptedData',decryptedData);
    playload = JSON.parse(atob(decryptedData.split(".")[1]));
    // console.log('playload',playload);
    localStorage.setItem("vendorRoleName", playload.roleName);
  }

  closePrompt = () => {
    this.setState({ companyModalOpenClose: false });
  };

  getUserPermissions() {
    let usertype = localStorage.getItem("usertype");
    // console.log("usertype174", usertype);
    if (usertype === "VENDOR") {
      this.props.getallpermissions().then((res) => {
        if (res.data) {
          localStorage.setItem("otherInfo", res.data);
          this.setState({ permission: res.data });
          let bytes = CryptoJS.AES.decrypt(
            res.data,
            REACT_APP_CRYPTO_SECRET_KEY
          );
          let decryptedData = bytes.toString(CryptoJS.enc.Utf8);
          // console.log("Header ===> decryptedData39", decryptedData);
          let permissionarray = decryptedData.split(",");
          // console.log("Header ===> permissionarray", permissionarray);
          this.setState({ permissionArray: permissionarray });
        }
      });
    }
  }

  checkPermission(checkFor) {
    const hasSome =
      this.state.permissionArray &&
      this.state.permissionArray.length > 0 &&
      checkFor.some((item) => this.state.permissionArray.includes(item));
    return hasSome;
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!!nextProps.readNotiRes && nextProps.readNotiRes) {
      this.getUnreadCount();
    }
  }

  notifications() {
    this.props
      .getNotificatioListAction(0)
      .then((res) => {
        this.setState({
          userNotifications: this.props.userNotifications.data || [],
          totalCount: this.props.userNotifications.count || 0,
          showLoader: false,
        });
      })
      .catch((err) => {
        this.setState({
          userNotifications: [],
          showLoader: false,
        });
      });
  }

  handleChange() {
    var datavalue = "";
    if (this.props.miniActive !== "collapsed") {
      datavalue = "collapsed";
    }
    this.setState({}, this.props.onUpdate(datavalue));
  }

  logout() {
    this.props.logout();

    if (localStorage.getItem("usertype") != "ADMIN") {
      let firstOpen = localStorage.getItem("firstOpen");
      let lastOpenedDate = localStorage.getItem("lastOpenedDate");
      let bannerDisplayed = localStorage.getItem("bannerDisplayed");
      localStorage.clear();
      const currentDate = new Date();
      localStorage.setItem("lastOpenedDate", lastOpenedDate);
      localStorage.setItem("firstOpen", firstOpen);
      localStorage.setItem("bannerDisplayed", false);
    } else {
      localStorage.clear();
    }

    this.props.history.push({
      pathname: "/login",
    });

    // window.location.reload();
  }

  /**
   * @desc read notificatiopn by id or all read
   * @param {*} id
   */
  readNotification(id) {
    let data = [];
    if (id !== undefined) {
      let notiIds = [];
      notiIds.push(id);
      data.push({ notificationIds: notiIds });
    }
    this.props
      .readNotificationsAction(data)
      .then((res) => {
        this.notifications();
        this.getUnreadCount();
      })
      .catch((err) => {});
  }

  /**
   * @desc show run time notification
   * @param {*} data
   */
  showNotificationToast(data) {
    let msgToshow = [];
    if (data.notificationType == 1) {
      //over due today
      msgToshow.push(<h4>Tasks OverDue</h4>);
      data.task.map((task) => {
        msgToshow.push(
          <a
            onClick={() => {
              this.readNotification(data._id);

              if (
                this.state.userType == message.VENDOR ||
                this.state.userType == message.BUYER
              ) {
                this.props.history.push({
                  pathname: "/artwork/detail/" + task.transactionId,
                  taskId: task._id,
                });
                localStorage.setItem("taskId", task._id);
              } else {
                this.props.history.push({
                  pathname: "/calendar/" + Date.parse(task.eventTimeStamp),
                });
              }
            }}
          >
            {task.transactionShortName} - {task.taskTitle}
          </a>
        );
        msgToshow.push(<br />);
      });
    }
    if (data.notificationType == 2) {
      // due  today
      msgToshow.push(<h4>Task Due Today</h4>);
      data.task.map((task) => {
        msgToshow.push(
          <a
            onClick={() => {
              this.readNotification(data._id);

              if (
                this.state.userType == message.VENDOR ||
                this.state.userType == message.BUYER
              ) {
                this.props.history.push({
                  pathname: "/artwork/detail/" + task.transactionId,
                  taskId: task._id,
                });
                localStorage.setItem("taskId", task._id);
              } else {
                this.props.history.push({
                  pathname: "/calendar/" + Date.parse(task.eventTimeStamp),
                });
              }
            }}
          >
            {task.transactionShortName} - {task.taskTitle}
          </a>
        );
      });
    }
    if (data.notificationType == 4) {
      // msg
      msgToshow.push(<h4>New Message</h4>);
      msgToshow.push(
        <a
          onClick={() => {
            this.readNotification(data._id);
            this.props.history.push({
              pathname: "/artwork/detail/" + data.task[0].transactionId,
              discussion: true,
              from: data.task[0].from,
            });
            localStorage.setItem("discussion", true);
            localStorage.setItem("from", data.from);
          }}
        >
          <p>
            New message received from{" "}
            <span className="color-light-blue-1 font-500">
              {this.getDisplayName(data.task[0])}
            </span>{" "}
            for transaction{" "}
            <span className="color-light-blue-1 font-500">
              {data.task[0].transactionShortName}
            </span>
          </p>
        </a>
      );
    }
    if (data.notificationType == 3) {
      // upload doc
      msgToshow.push(<h4>Document Uploaded</h4>);
      msgToshow.push(
        <a
          onClick={() => {
            this.readNotification(data._id);
            this.props.history.push({
              pathname: "/artwork/detail/" + data.task[0].transactionId,
              document: true,
              notification: true,
            });
            localStorage.setItem("doc", true);
          }}
        >
          <p>
            Document has been uploaded by{" "}
            <span className="color-light-blue-1 font-500">
              {this.getDisplayName(data.task[0])}
            </span>{" "}
            for transaction{" "}
            <span className="color-light-blue-1 font-500">
              {data.task[0].transactionShortName}
            </span>
          </p>
        </a>
      );
    }
    // if (data.notificationType == 5) {
    //   // payment method update
    //   msgToshow.push(<h4>Update payment method</h4>);
    //   msgToshow.push(
    //     <a
    //       onClick={() => {
    //         this.readNotification(data._id);
    //         this.props.history.push("/Subscription/SubscriptionDetail");
    //       }}
    //     >
    //       <p>{data.message}</p>
    //     </a>
    //   );
    // }
    if (data.notificationType == 6) {
      // require action
      msgToshow.push(<h4>Require Action (authentication)</h4>);
      msgToshow.push(
        <p>
          {data.message}
          <a
            href={data.redirectionURL}
            target="_blank"
            onClick={() => {
              this.readNotification(data._id);
            }}
          >
            Click here
          </a>
          &nbsp;for authentication.
        </p>
      );
    }
    if (data.notificationType == 7) {
      // upcoming invoice
      msgToshow.push(<h4>Upcoming invoice</h4>);
      msgToshow.push(<p>{data.message}</p>);
    }
    this.setState({ notificationMsg: msgToshow }, () => {
      this.setState({ showNotification: true });
    });
  }

  /**
   * @desc get name of user for display within notification
   * @param {*} n
   */
  getDisplayName(n) {
    let displayName = "unknown";
    if (n.from._id !== undefined) {
      displayName = n.from.firstname + " " + n.from.lastname;
    } else {
      if (n.from.email !== undefined && n.from.email.address !== undefined) {
        displayName = n.from.email.address;
      }
      if (n.from.mobileNumber !== undefined) {
        displayName = <PhoneNumber phoneNumber={n.from.mobileNumber} />;
      }
    }
    return displayName;
  }

  render() {
    var username =
      localStorage.getItem("fname") + " " + localStorage.getItem("lname");

    // console.log("this.props.profileData.avatar", this.props.profileData.avatar);

    return (
      <>
        {this.state.showLoader && (
          <div className="page-loader">
            <div className="page-loader-inner">
              <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        )}
        <Navbar expand="lg" className="align-items-center nav-admin">
          <Navbar.Brand>
            <img src={Logo} alt="Logo" className="logo-mobile" />
          </Navbar.Brand>
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ml-auto align-items-center">
              {/* {localStorage.getItem("isActive") === "false" && (
                <Nav.Item>
                  <p
                    className="header-alert-text"
                    onClick={() => {
                      this.props.history.push(
                        "/Subscription/SubscriptionDetail"
                      );
                    }}
                  >
                    Your subscription is not active, Please{" "}
                    <strong>click here</strong> to continue.
                  </p>
                </Nav.Item>
              )} */}
              {/* <Nav.Item>
                <Dropdown className="dropdown-notification">
                  <Dropdown.Toggle
                    variant="transparent"
                    id="dropdown-notification"
                    className="d-flex align-items-center font-14"
                  >
                    <Notifications className="w-18" />
                    {this.state.totalUnreadCnt > 0 ? (
                      <span>{this.state.totalUnreadCnt}</span>
                    ) : (
                      ""
                    )}
                  </Dropdown.Toggle>

                  <Dropdown.Menu className="dropdown-menu-right dropdown-notification-menu">
                    <h2>Notifications</h2>
                    <div className="dropdown-notification-menu-inner">
                      <Dropdown.Item as="div">
                        {(this.state.userNotifications.length === 0 &&
                          this.state.totalCount == 0) ||
                        (!!this.props.clearNotiRes &&
                          this.props.clearNotiRes.success) ? (
                          <div className={"notification-single "}>
                            <Row>
                              <Col className="col-auto">No notifications</Col>
                            </Row>
                          </div>
                        ) : (
                          <>
                            <NotificationList
                              notificationlist={this.state.userNotifications}
                              readNotification={this.readNotification}
                              fromHeader={true}
                              history={this.props.history}
                            />
                          </>
                        )}
                      </Dropdown.Item>
                    </div>
                    <Dropdown.Item as="div">
                      <div className="dropdown-notification-footer">
                        <Button href="#/notification" variant="transparent">
                          View All
                        </Button>
                      </div>
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </Nav.Item> */}
              <Nav.Item>
                <Dropdown className="user-dropdown">
                  <Dropdown.Toggle
                    variant="transparent"
                    id="dropdown-basic"
                    className="d-flex align-items-center font-14"
                    style={{ color: "#FFFFFF" }}
                  >
                    <span className="user-profile">
                      <img
                        src={
                          this.props.profileData.avatar &&
                          this.props.profileData.avatar !== "-"
                            ? UrlConstants.AdminCreateTransactionUrl +
                              "/upload?id=" +
                              this.props.profileData._id +
                              "&img=" +
                              this.props.profileData.avatar
                            : userImage
                        }
                        alt=""
                      />
                    </span>
                    <span className="ml-2 user-dropdown-name">{username}</span>
                  </Dropdown.Toggle>

                  <Dropdown.Menu className="dropdown-menu-right">
                    <Dropdown.Item href="/#/UserProfile">
                      {" "}
                      Profile{" "}
                    </Dropdown.Item>
                    <Dropdown.Item href="/#/changePassword">
                      {" "}
                      Change Password{" "}
                    </Dropdown.Item>
                    {this.state.showChangecompanyOption ? (
                      <Dropdown.Item
                        onClick={() =>
                          this.setState({ companyModalOpenClose: true })
                        }
                      >
                        {" "}
                        Change Studio{" "}
                      </Dropdown.Item>
                    ) : (
                      ""
                    )}
                    {this.state.userType === message.ADMIN ? (
                      <Dropdown.Item href="/#/settings">
                        {" "}
                        Settings{" "}
                      </Dropdown.Item>
                    ) : (
                      ""
                    )}
                    {/* {this.state.userType === message.ADMIN ? (
                      <Dropdown.Item href="/#/systemnotifications">
                        {" "}
                        System Notifications{" "}
                      </Dropdown.Item>
                    ) : (
                      <Dropdown.Item href="/#/notificationsetting">
                        Notification Settings
                      </Dropdown.Item>
                    )} */}
                    {/* {this.state.userType === message.ADMIN ? (
                      <Dropdown.Item href="/#/plansetting">
                        {" "}
                        Plan Configuration{" "}
                      </Dropdown.Item>
                    ) : (
                      ""
                    )}
                    {this.state.userType === message.ACCTOWNER &&
                    localStorage.getItem(code.IS_STRIPE_ENABLED) === "true" ? (
                      <Dropdown.Item href="/#/Subscription/SubscriptionDetail">
                        {" "}
                        Manage Plan{" "}
                      </Dropdown.Item>
                    ) : (
                      ""
                    )}
                    {this.state.userType === message.ACCTOWNER &&
                    localStorage.getItem(code.IS_STRIPE_ENABLED) === "true" ? (
                      <Dropdown.Item href="/#/Subscription/ManagePayment">
                        {" "}
                        Manage Payment{" "}
                      </Dropdown.Item>
                    ) : (
                      ""
                    )} */}
                    {(this.state.userType === message.ACCTOWNER &&
                      localStorage.getItem(code.IS_BILLING_ENABLED) ===
                        "true") ||
                    this.checkPermission([message.view_plan_details]) ? (
                      <Dropdown.Item href="/#/BillingModule/UserBillingPlanDetails">
                        {" "}
                        My Billing Plan{" "}
                      </Dropdown.Item>
                    ) : (
                      ""
                    )}
                    {(this.state.userType === message.ACCTOWNER &&
                      localStorage.getItem(code.IS_BILLING_ENABLED) ===
                        "true") ||
                    this.checkPermission([
                      message.view_payment_method,
                      message.manage_payment_method,
                    ]) ? (
                      <Dropdown.Item href="/#/BillingModule/BillingPaymentMethods">
                        {" "}
                        Billing Payment Method{" "}
                      </Dropdown.Item>
                    ) : (
                      ""
                    )}
                    {(this.state.userType === message.ACCTOWNER &&
                      localStorage.getItem(code.IS_BILLING_ENABLED) ===
                        "true") ||
                    this.checkPermission([
                      message.view_billing_details,
                      message.manage_billing_details,
                    ]) ? (
                      <Dropdown.Item href="/#/BillingModule/BillingPaymentDetails">
                        {" "}
                        Billing Payment Details{" "}
                      </Dropdown.Item>
                    ) : (
                      ""
                    )}
                    <Dropdown.Item href="#" onClick={() => this.logout()}>
                      Logout
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </Nav.Item>
            </Nav>
            <Nav className="ml-auto align-items-center">
              <h3 className="mb-0 text-capitalize" style={{ color: "#4a629e" }}>
                {localStorage.getItem("companyName")
                  ? localStorage.getItem("companyName")
                  : ""}
              </h3>
            </Nav>
            <Button
              variant="transparent"
              className="color-grey-1 pr-2"
              onClick={(e) => this.handleChange(e)}
            >
              <Menu className="menu-icn" style={{ color: "#FFFFFF" }} />
              <Close className="close-icn" />
            </Button>
          </Navbar.Collapse>
        </Navbar>

        {/* Notification Toast */}
        <Toast
          className="notification-toast"
          onClose={() =>
            this.setState({ showNotification: !this.state.showNotification })
          }
          show={this.state.showNotification}
          delay={10000}
          autohide
        >
          <Toast.Header />
          <Toast.Body className="notification-single">
            <Row>
              <Col className="col-auto">
                <div className="nf-icn nf-yellow">
                  <Chat />
                </div>
              </Col>
              <Col className="pl-0">{this.state.notificationMsg}</Col>
            </Row>
          </Toast.Body>
        </Toast>

        {/* modal popup for chossing account owners */}
        <Modal
          show={this.state.companyModalOpenClose}
          onHide={() => this.closePrompt()}
          aria-labelledby="example-custom-modal-styling-title"
          backdrop={false}
          size="md"
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-custom-modal-styling-title">
              Choose Studio
            </Modal.Title>
          </Modal.Header>

          <Modal.Body className="pb-4">
            <ChangeCompany chooseComapnyCallback={this.chooseComapnyCallback} />
          </Modal.Body>
          <Modal.Footer />
        </Modal>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.reducer.isAuthenticated,
    profileData: state.reducer.profileData,
    userNotifications: state.reducer.userNotifications,
    clearNotiRes: state.reducer.clearNotiRes,
    readNotiRes: state.reducer.readNotiRes,
    renderSidebar: state.reducer.renderSidebar,
    renderHeader: state.reducer.renderHeader,
  };
};

export default connect(
  mapStateToProps,
  {
    logout,
    myProfileAction,
    getNotificatioListAction,
    readNotificationsAction,
    getNotificatiosCntAction,
    getallpermissions,
    updatetoken,
    grtAllCompanylistbyVendorId,
    setRenderSide,
    getCurrentSystemVersionAction,
  }
)(Header);
